import { render, staticRenderFns } from "./AnhaengerShow.vue?vue&type=template&id=636d8ff9"
import script from "./AnhaengerShow.vue?vue&type=script&lang=js"
export * from "./AnhaengerShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports